import React from "react";

export const STATUS = {
  verde: { color: "#16A34A", bg: "bg-emerald-50", text: "text-emerald-700", ring: "ring-emerald-200", label: "Va bien" },
  amarillo: { color: "#F59E0B", bg: "bg-amber-50", text: "text-amber-700", ring: "ring-amber-200", label: "Más o menos" },
  rojo: { color: "#DC2626", bg: "bg-red-50", text: "text-red-700", ring: "ring-red-200", label: "Atención" },
};

// Small traffic-light dot
export function SemaforoDot({ status = "amarillo", size = 10, pulse = false, className = "" }) {
  const s = STATUS[status] || STATUS.amarillo;
  return (
    <span
      className={`inline-block rounded-full shrink-0 ${pulse ? "animate-pulse" : ""} ${className}`}
      style={{ width: size, height: size, backgroundColor: s.color, boxShadow: `0 0 0 3px ${s.color}22` }}
      title={s.label}
      data-testid={`semaforo-${status}`}
    />
  );
}

// Badge with label
export function SemaforoBadge({ status = "amarillo", showLabel = true, className = "" }) {
  const s = STATUS[status] || STATUS.amarillo;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-xs font-bold uppercase tracking-wide ring-1 ${s.bg} ${s.text} ${s.ring} ${className}`}
      data-testid={`semaforo-badge-${status}`}
    >
      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: s.color }} />
      {showLabel && s.label}
    </span>
  );
}

// Vertical traffic-light (3 lamps) — the active one lit
export function TrafficLight({ status = "amarillo", className = "" }) {
  const order = ["rojo", "amarillo", "verde"];
  return (
    <div className={`inline-flex flex-col gap-1 p-1.5 bg-slate-800 rounded-md ${className}`} title={STATUS[status]?.label}>
      {order.map((k) => (
        <span
          key={k}
          className="w-2.5 h-2.5 rounded-full transition-opacity"
          style={{
            backgroundColor: STATUS[k].color,
            opacity: k === status ? 1 : 0.18,
          }}
        />
      ))}
    </div>
  );
}
